import { WidgetType } from '@/modules/shared/types';
import { WidgetWizardStep, WidgetWizardTab } from '@/components/widget-wizard';
import { Steps as ScatterChartSteps } from '@/components/widgets/components/scatter';
import { Steps as TimeChartSteps } from '@/components/widgets/components/timechart';
import { Steps as StackedTimeChartSteps } from '@/components/widgets/components/timechart-stacked';
import { Steps as GeneratorChartSteps } from '@/components/widgets/components/generatorchart';
import { Steps as StackedGeneratorChartSteps } from '@/components/widgets/components/generatorchart-stacked';
import { Steps as NumberSteps } from '@/components/widgets/components/number';
import { Steps as DistributionSteps } from '@/components/widgets/components/distribution';
import { Steps as LogsSteps } from '@/components/widgets/components/logs';
import { Steps as LatestLogsSteps } from '@/components/widgets/components/latest-logs';
import { Steps as AvailabilitySteps } from '@/components/widgets/components/availability';
import { Steps as CommissionsSteps } from '@/components/widgets/components/commissions';
import { Steps as TableSteps } from '@/components/widgets/components/table';
import { Steps as MapSteps } from '@/components/widgets/components/map';
import { Steps as WindroseSteps } from '@/components/widgets/components/windrose';
import { Steps as WeatherMapSteps } from '@/components/widgets/components/map-weather';
import { Steps as ForecastSteps } from '@/components/widgets/components/forecast';
import { Steps as HeatmapSteps } from '@/components/widgets/components/heatmap';
import { Steps as PowerCurveSteps } from '@/components/widgets/components/powercurve';
import { Steps as NoteSteps } from '@/components/widgets/components/note';
import { Steps as OperatorForecastSteps } from '@/components/widgets/components/operator-forecast';

export class WidgetStepUtils {
    public static getWizardStepsForWidgetType(widgetType: WidgetType|string): WidgetWizardStep[] {
        switch (widgetType) {
            case WidgetType.ScatterChart: return ScatterChartSteps;
            case WidgetType.TimeChart: return TimeChartSteps;
            case WidgetType.StackedTimeChart: return StackedTimeChartSteps;
            case WidgetType.GeneratorChart: return GeneratorChartSteps;
            case WidgetType.StackedGeneratorChart: return StackedGeneratorChartSteps;
            case WidgetType.Gauge:
            case WidgetType.Number: return NumberSteps;
            case WidgetType.Distribution: return DistributionSteps;
            case WidgetType.Logs: return LogsSteps;
            case WidgetType.LatestLogs: return LatestLogsSteps;
            case WidgetType.Availability: return AvailabilitySteps;
            case WidgetType.Commissions: return CommissionsSteps;
            case WidgetType.Table: return TableSteps;
            case WidgetType.Map: return MapSteps;
            case WidgetType.Windrose: return WindroseSteps;
            case WidgetType.WeatherMap: return WeatherMapSteps;
            case WidgetType.Forecast: return ForecastSteps;
            case WidgetType.Heatmap: return HeatmapSteps;
            case WidgetType.PowerCurve: return PowerCurveSteps;
            case WidgetType.Note: return NoteSteps;
            case WidgetType.OperatorForecast: return OperatorForecastSteps;
            default:
                return [
                    { name: 'widget-wizard.tab.data', tab: WidgetWizardTab.Data },
                    { name: 'widget-wizard.tab.time', tab: WidgetWizardTab.Time },
                    { name: 'widget-wizard.tab.general', tab: WidgetWizardTab.General },
                ];
        }
    }
}
